import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';



export function* getInstanceDetails(params) {
    try {
        let response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        yield put({
            skip: params.skip,
            type: actions.CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS,
            data: response?.data || []
        });
    } catch (error) {
        yield put({ type: actions.CUSTOMER_SCHEDULEINSTANCE_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getInstanceClearDetails() {
    yield put({
        type: actions.CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS,
    });
}


export default function* instanceSaga() {
    yield all([
        takeEvery(actions.CUSTOMER_SCHEDULEINSTANCE_DETAILS_START, getInstanceDetails),
        takeEvery(actions.CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_START, getInstanceClearDetails)
    ]);
}